import Vue from 'vue';
import Router from 'vue-router';
import Login from "./views/Login";
import Register from "./views/Register";
import EditProfileUser from "./views/EditProfileUser";
import ChangePasswordUser from "./views/ChangePasswordUser";
import HomeSearch from "./views/HomeSearch";
import OrderHistory from "./views/OrderHistory";
import Help from "./views/Help";
import ShowDetail from "./views/ShowDetail";
// import RememberPassword from "./views/rememberPassword"
import ForgotPassword from "./views/ForgotPassword";
import ResetPasswordForm from "./views/ResetPasswordForm";

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'login',
            component: Login
        },
        // {
        //     path: '/remember-password',
        //     name: 'remember-password',
        //     component: RememberPassword
        // },
        {
            path: '/register',
            name: 'register',
            component: Register
        },
        {
            path: '/edit-profile-user',
            name: 'edit-profile-user',
            component: EditProfileUser
        },
        {
            path: '/change-password-user',
            name: 'change-password-user',
            component: ChangePasswordUser
        },
        {
            path: '/home',
            name: 'home',
            component: HomeSearch
        },
        {
            path: '/order-history',
            name: 'order-history',
            component: OrderHistory
        },
        {
            path: '/help',
            name: 'help',
            component: Help
        },
        {
            path: '/show-detail',
            name: 'show-detail',
            component: ShowDetail
        },

        {
            path: '/reset-password',
            name: 'reset-password',
            component: ForgotPassword,
            meta: {
                auth:false
            }
        },
        {
            path: '/reset-password/:token',
            name: 'reset-password-form',
            component: ResetPasswordForm,
            meta: {
                auth:false
            }
        }
    ]
});
